module.exports = __webpack_public_path__ + "img/whoweare.ba6600a0.svg";